export const parseVisitTableData = ({ data }) =>
  data.map((item) => ({
    agencyName: item.agency_name,
    violations: item.violations,
    totalVisits: item.total_visits,
    violationRate: item.violation_rate,
  }));
